import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_component_font_awesome_icon, {
    icon: _ctx.currentOrder === _ctx.fieldName ? (_ctx.reverse ? 'sort-down' : 'sort-up') : 'sort'
  }, null, 8 /* PROPS */, ["icon"]))
}